import { MenuItem, Select, TextField } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import moment from "moment";

const SelfInformationForm = ({ formik, dataSelection }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="w-full">
        <TextField
          fullWidth
          placeholder="Nama peminjam sesuai KTP"
          label="Nama peminjam sesuai KTP"
          value={formik.values.data.account_info.name}
          onChange={(e) =>
            formik.setFieldValue("data.account_info.name", e.target.value)
          }
        />
      </div>
      <div className="w-full">
        <Select
          value={
            formik.values.data.data_info.gender_id === ""
              ? "none"
              : formik.values.data.data_info.gender_id
          }
          onChange={(e) =>
            formik.setFieldValue("data.data_info.gender_id", e.target.value)
          }
          sx={{ width: "100%" }}
        >
          <MenuItem value={"none"} disabled>
            Jenis Kelamin
          </MenuItem>
          {dataSelection
            ? dataSelection.gender?.map((item) => (
                <MenuItem value={item.gender_id}>{item.gender}</MenuItem>
              ))
            : null}
        </Select>
      </div>
      <div className="w-full">
        <TextField
          fullWidth
          placeholder="Tempat Lahir"
          label="Tempat Lahir"
          value={formik.values.data.data_info.place_of_birth}
          onChange={(e) =>
            formik.setFieldValue(
              "data.data_info.place_of_birth",
              e.target.value
            )
          }
        />
      </div>
      <div className="w-full">
        <DesktopDatePicker
          fullWidth
          onChange={(newExpiredDate) =>
            formik.setFieldValue(
              "data.data_info.date_of_birth",
              newExpiredDate ? moment(newExpiredDate).format("YYYY-MM-DD") : ""
            )
          }
          value={
            !formik.values.data.data_info.date_of_birth ||
            formik.values.data.data_info.date_of_birth === ""
              ? null
              : formik.values.data.data_info.date_of_birth
          }
          renderInput={(params) => {
            return (
              <TextField
                fullWidth
                {...params}
                placeholder="Tanggal Lahir"
                label="Tanggal Lahir"
              />
            );
          }}
          disableFuture
        />
      </div>
      <div className="w-full">
        <TextField
          fullWidth
          placeholder="NIK"
          label="NIK"
          value={formik.values.data.data_info.nik}
          onChange={(e) => {
            if (!isNaN(Number(e.target.value)) && e.target.value.length <= 16)
              formik.setFieldValue("data.data_info.nik", e.target.value);
          }}
        />
      </div>
      <div className="w-full">
        <TextField
          fullWidth
          placeholder="Nomor Handphone"
          label="Nomor Handphone"
          value={formik.values.data.account_info.phone_number}
          onChange={(e) => {
            if (e.target.value.match(/^[\d]+$/g) || e.target.value === "")
              formik.setFieldValue(
                "data.account_info.phone_number",
                e.target.value
              );
          }}
        />
      </div>
      <div className="w-full">
        <TextField
          fullWidth
          placeholder="Email"
          label="Email"
          value={formik.values.data.account_info.email}
          onChange={(e) =>
            formik.setFieldValue("data.account_info.email", e.target.value)
          }
        />
      </div>
      <div className="w-full">
        <Select
          value={
            formik.values.data.data_info.education_id === ""
              ? "none"
              : formik.values.data.data_info.education_id
          }
          onChange={(e) =>
            formik.setFieldValue("data.data_info.education_id", e.target.value)
          }
          sx={{ width: "100%" }}
        >
          <MenuItem value={"none"} disabled>
            Pendidikan Terakhir
          </MenuItem>
          {dataSelection
            ? dataSelection.education?.map((item) => (
                <MenuItem value={item.education_type_id}>
                  {item.education_type}
                </MenuItem>
              ))
            : null}
        </Select>
      </div>
      <div className="w-full">
        <Select
          value={
            formik.values.data.data_info.marital_status_id === ""
              ? "none"
              : formik.values.data.data_info.marital_status_id
          }
          onChange={(e) =>
            formik.setFieldValue(
              "data.data_info.marital_status_id",
              e.target.value
            )
          }
          sx={{ width: "100%" }}
        >
          <MenuItem value={"none"} disabled>
            Status Pernikahan
          </MenuItem>
          {dataSelection
            ? dataSelection.marital?.map((item) => (
                <MenuItem value={item.marital_status_id}>
                  {item.marital_status}
                </MenuItem>
              ))
            : null}
        </Select>
      </div>
      <div className="w-full">
        <Select
          value={
            formik.values.data.data_info.religion_id === ""
              ? "none"
              : formik.values.data.data_info.religion_id
          }
          onChange={(e) =>
            formik.setFieldValue("data.data_info.religion_id", e.target.value)
          }
          sx={{ width: "100%" }}
        >
          <MenuItem value={"none"} disabled>
            Agama
          </MenuItem>
          {dataSelection
            ? dataSelection.religion?.map((item) => (
                <MenuItem value={item.religion_id}>{item.religion}</MenuItem>
              ))
            : null}
        </Select>
      </div>
      <div className="w-full">
        <TextField
          fullWidth
          placeholder="Nama Ibu Kandung"
          label="Nama Ibu Kandung"
          value={formik.values.data.data_info.mother_name}
          onChange={(e) =>
            formik.setFieldValue("data.data_info.mother_name", e.target.value)
          }
        />
      </div>
    </div>
  );
};

export default SelfInformationForm;
